module.exports = __webpack_public_path__ + "img/file-----------1x-png-1@1x.11d24469.png";